import { Message } from "../Model/Message";
export class MessagesFactory {
    constructor(uuidGenerator) {
        this.uuidGenerator = uuidGenerator;
    }
    create(roomId, id = this.uuidGenerator.createUuid(), enabled = true, text = '') {
        return new Message(id, roomId, enabled, text);
    }
}
